<template>
  <div class="dialog-area">
    <el-dialog
      v-model="_isShow"
      width="90%"
      top="0"
      lock-scroll
      center
      show-close
      destroy-on-close
      :title="$t('camera_list')"
    >
      <div class="instock-location">
        <div class="display-in-center">
          <div style="min-height:170px; max-height: 200px;overflow-x: hidden; overflow-y: auto;" class="my-3">
            <el-radio-group v-model="_selectedCamera" class="ml-4">
              <div v-for="camera in cameras" :key="camera.deviceId" class="my-2 flex items-start">
                <el-radio :label="camera.deviceId"> {{ camera.label }}</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="flex flex-col items-center">
          <el-button @click="closeDialog">
            {{ $t('cancel') }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop, PropSync } from 'vue-property-decorator'

@Options({
  emits: ['update:isShow', 'update:selectedCamera'],
  name: 'SelectionCameraPopup',
})
export default class SelectionCameraPopup extends Vue {
  @PropSync('isShow', { type: Boolean }) _isShow!: boolean
  @PropSync('selectedCamera', { type: String }) _selectedCamera!: string
  @Prop({ type: Array }) cameras!: MediaDeviceInfo[]

  closeDialog() {
    this._isShow = false
  }
}
</script>
<style lang="scss">
.edit-view.view {
  padding-left: 0;
  padding-right: 0;
}
</style>
